export const Types = {
  START_APPLICANT_FILTER: 'START_APPLICANT_FILTER',
  END_APPLICANT_FILTER: 'END_APPLICANT_FILTER',

  START_POSITION_FILTER: 'START_POSITION_FILTER',
  END_POSITION_FILTER: 'END_POSITION_FILTER',
};
